// extracted by mini-css-extract-plugin
export default {"Modal":"EditAdminInfoModal_Modal__JhHmZ","TextEditor":"EditAdminInfoModal_TextEditor__Nb02H","Buttons":"EditAdminInfoModal_Buttons__AxA1q"};